import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <ExclamationTriangleIcon className="mx-auto h-16 w-16 text-warning-500" />
          <h1 className="mt-6 text-6xl font-bold text-secondary-900">404</h1>
          <h2 className="mt-2 text-2xl font-semibold text-secondary-700">Page Not Found</h2>
          <p className="mt-2 text-secondary-600">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/dashboard"
            className="btn-primary inline-flex items-center justify-center"
          >
            <HomeIcon className="h-5 w-5 mr-2" />
            Go to Dashboard
          </Link>
          
          <div className="text-sm text-secondary-500">
            <p>Need help? Contact your system administrator.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;